import { BreadCrumb } from 'primereact/breadcrumb';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import React from 'react';

import {sample_questionnaire} from "../../utils/common";
// import history from "../RouterWithAcess/history";
import "../../style/poll.css";

import "../../style/questionnaire.css"
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { useNavigate } from 'react-router-dom';
// import { useParams } from 'react-router-dom';

function Questionnaire(props){
    const navigate = useNavigate();
    // let { id } = useParams()
    const [questionnaire, setQuestionnaire] = React.useState(sample_questionnaire)

    const handleEditOption = (e, index) => {
        var questions = [...questionnaire.questions]
        questions[index].optionText = e.value
        setQuestionnaire({...questionnaire, questions : questions})
    }

    const handleEditCategory = (e, qid, opid) => {
        const questions = [...questionnaire.questions]
        questions[qid].options[opid].optionCategory = e.target.value
        setQuestionnaire({...questionnaire, questions : questions})
    }
    const makeEditable = (index, val) => {
        var questions = [...questionnaire.questions]
        questions[index].edit = val
        setQuestionnaire({...questionnaire, questions : questions})
    }

    const items = [
        { label: "Risk Assessment", url: "/Questionnaires" },
        { label:  "Answer Assessment" },
    ];

    const home = {
        icon: "pi pi-home",
        url: "/",
    };

    return (
        <div className="app__grid main-box">
            <BreadCrumb model={items} home={home} style={{marginBottom:"20px"}}/>
            
            <div>
            <h2>{sample_questionnaire.title}</h2>
            <div className="notif-date">{sample_questionnaire.desc}</div>
            <div className="p-fluid formgrid grid mt-4">
                <div className="field col md:col-6 sm:col-12">
                    <label style={{fontWeight:"bold"}}>Meeting Name</label>
                    <InputText
                        className="widthFull"
                        required
                    />
                </div>
            </div>
            <div className="pt-4 pl-2 pb-6">
            {
                sample_questionnaire.questions.map((item, index) => {
                    const question = sample_questionnaire.questions[index];
                    const ques_index = index
                    return (
                        <div className="pb-4" key={index}>
                            <div style={{fontWeight : 650}} className="box">Q{index + 1}. {item.questionText}
                                {
                                    question.edit
                                ?
                                    <span
                                        className="expand"
                                        onClick={() => makeEditable(index, false)}
                                    >
                                        Save
                                    </span>
                                :
                                    <span
                                        onClick={() => makeEditable(index, true)}
                                        className="floatRight"
                                    >
                                        <i className="pi pi-pencil"></i>
                                    </span> 
                                }
                                <span className="notif-date floatRight">Percentage: 33
                                    {/* <InputText className="p-inputtext-sm ml-3" value={33}></InputText> */}
                                </span>
                                <div className="clear"></div>
                            </div>
                            <div className="grid pl-2 pt-3">
                            {
                                question.options.map((item, index) => 
                                    <div className="radioDiv col-12 md:col-6 lg:col-4" key={index}>
                                        <RadioButton value = {item.optionText} inputId={item.optionText + index} name="optionText" onChange={(e) => handleEditOption(e, ques_index)} checked={question.optionText === item.optionText}/>
                                        <label style={{marginLeft : "0.5rem"}} htmlFor={item.optionText}>{item.optionText}</label>
                                        <span className="notif-date pl-4">Result Type: </span>
                                        {question.edit ?
                                            <Dropdown className="p-dropdown-sm dropDown" 
                                                options={["Category 1", "Category 2", "Category 3"]}
                                                value={item.optionCategory}
                                                onChange={(e) => handleEditCategory(e, ques_index, index)}
                                            ></Dropdown>
                                            :
                                            <span className="notif-date">{item.optionCategory}</span>
                                        }
                                    </div>
                                )
                            }
                            </div>
                        </div>
                    )
                })
            }
            </div>
            <Button className="p-button p-button-sm diag-save-button floatRight" label="Submit Results"
                onClick = {(e) => navigate("/pollResults")}
            />
            <Button className="p-button p-button-sm diag-save-button floatRight mr-6" label="Discard"
                onClick = {(e) => navigate(-1)}
            />
            </div>
        </div>
    )
}

export default Questionnaire
